

class petitionService {

    constructor(axios, baseUrl) {
        this.axios = axios;
        this.baseUrl = `${baseUrl}/petition`;

    }
    rejectExplain(data){
        
        let self = this;
        let datos = Object.assign({}, {merchan_id:data.merchanId,content:data.content, transaction_id:data.transactionId, token:data.token})
        return self.axios.post( `${self.baseUrl}/reject`, datos )
    }
    approve(data){
        
        let self = this;
        //let datos = Object.assign({}, {merchan_id:data.merchanId, transaction_id:data.transactionId, token:data.token})
        return self.axios.post( `${self.baseUrl}/approve`, data )
    }
    
}
export default petitionService


// WEBPACK FOOTER //
// ./src/services/petitionService.js